import { MODEL_CLASSIFICATIONS_SUCCESS, MODEL_CLASSIFICATIONS_ERROR, MODEL_CLASSIFICATIONS, DELETE_MODEL_CLASSIFICATION_SUCCESS, DELETE_MODEL_CLASSIFICATION_ERROR, DELETE_MODEL_CLASSIFICATION, EDIT_MODEL_CLASSIFICATION, EDIT_MODEL_CLASSIFICATION_SUCCESS, EDIT_MODEL_CLASSIFICATION_ERROR, ADD_MODEL_CLASSIFICATION_SUCCESS, ADD_MODEL_CLASSIFICATION_ERROR, ADD_MODEL_CLASSIFICATION, MODEL_CLASSIFICATION_DETAILS_ERROR, MODEL_CLASSIFICATION_DETAILS_SUCCESS, MODEL_CLASSIFICATION_DETAILS, PREDICTION_LEVEL_LIST, PREDICTION_LEVEL_LIST_SUCCESS, PREDICTION_LEVEL_LIST_ERROR } from './constants';


export default function retrainingDataReducer(state, action) {
	
	let modelClassificationDate = [];
	let predictionlevel = [];
	switch (action.type) {
    
	case MODEL_CLASSIFICATIONS:
		return { ...state, loading: true, error: false };
                    
	case MODEL_CLASSIFICATIONS_SUCCESS:
		if(action?.payload?.data){
			action.payload.data && action.payload.data.map((item) => {
				
				modelClassificationDate.push({
					id : item.id,
					modelLevel : item.modelLevel,
					parentmodelLevel : item.parentmodelLevel,
					isSynced : item.isSynced,
					alias : item &&  item?.alias ? item?.alias : item?.modelLevel ? item?.modelLevel : '-',
					description : item?.description ? item.description : '',
					loaderType : item?.loaderType ? item.loaderType : '',
					isSubmodel : item?.isSubmodel ? item.isSubmodel : null,
					predictionlevelId : item?.predictionlevelId ? item.predictionlevelId : null,
					predictlvlname : item?.predictionlevel && item.predictionlevel?.name ? item.predictionlevel?.name : ''
					
				});
                
			});
		}	
        

		return { ...state, loading: false, modelClassificationDate : modelClassificationDate , error: false };
                    
	case MODEL_CLASSIFICATIONS_ERROR:
		return { ...state, loading: false, error: true };

	case DELETE_MODEL_CLASSIFICATION:
		return { ...state, loading: false };
    
	case DELETE_MODEL_CLASSIFICATION_SUCCESS:
		return { ...state, loading: false, error: false };
    
	case DELETE_MODEL_CLASSIFICATION_ERROR:
		return { ...state, loading: false, error: true };

	case EDIT_MODEL_CLASSIFICATION:
		return { ...state, loading: true, error: false };
    
	case EDIT_MODEL_CLASSIFICATION_SUCCESS:
		return { ...state,  loading: false, error : false };
    
	case EDIT_MODEL_CLASSIFICATION_ERROR:
		return {...state, loading : false, error : true};

	case ADD_MODEL_CLASSIFICATION:
		return { ...state, loading: true };
	case ADD_MODEL_CLASSIFICATION_SUCCESS:
		return { ...state, loading: false, error: false };
    
	case ADD_MODEL_CLASSIFICATION_ERROR:
		return {...state, loading : false, error : true};

	case MODEL_CLASSIFICATION_DETAILS:
		return { ...state, loading: true };
    
	case MODEL_CLASSIFICATION_DETAILS_SUCCESS:
		return { ...state, loading: false, details:action.payload, error: false };
    
	case MODEL_CLASSIFICATION_DETAILS_ERROR:
		return { ...state, loading: false, error: true };
	case PREDICTION_LEVEL_LIST:
		return {...state, loading: true, error : false};
	case PREDICTION_LEVEL_LIST_SUCCESS : 
			
			
		if (action.payload && action.payload && action.payload.length > 0) {
			action.payload.map( (item) => {
				let data = {};                        
				data.id = item.id ? item.id : 0;
				data.name = item.name;
				return predictionlevel.push(data);
			});       
			return { ...state, predictionlevel:predictionlevel ,loading: false, error: false };
		} else {
			if (action.payload && action.payload && action.payload.length === 0) {
				return { ...state, predictionlevel : [] , loading: false, error: false };
			} else {
				return { ...state , loading: false, error: true };
			}
		}
	case PREDICTION_LEVEL_LIST_ERROR : 
		return { ...state, loading : false, error : true };
    
	default: 
		throw Error('Unknown action: ' + action.type);
      
	}
}